@if (table.value) {
  <div class="ms-2 mt-4 mb-2" style="overflow-x: auto;">
    {{table.title}}
    <button type="button" class="btn btn-primary" (click)="downloadTable('api/control/report/table-export') ">
      <lucide-icon name="cloud-download" size="16"></lucide-icon>
      {{'DATATABLE.DOWNLOAD' |
      translate}}
    </button>
    <table class="mt-4 mb-2 table table-stripped" style="margin: 0 20; width: 100%;">
      <thead>
        @for (colGroups of table?.value?.columns; track colGroups) {
          <tr>
            @for (colH of colGroups; track colH) {
              <th class="text-center" style="min-width: 280px;"
                [attr.rowspan]="colH.rowspan" [attr.colspan]="colH.colspan">
                @if (colH.type==='year') {
                  <span>{{getYear(colH.order)}}</span>
                } @else {
                  {{colH.name}}
                }
              </th>
            }
          </tr>
        }
      </thead>
      @for (row of table?.value?.rows; track row; let rowIndex = $index) {
        <tr style="border-bottom: 1px solid var(--border);">
          @for (rowElement of row; track rowElement; let index = $index) {
            <td style="padding: 5px;">
              @if (rowElement.key && findCol(table?.value?.columns,rowElement.key)) {
                <div
                  >
                  @switch (findCol(table?.value?.columns,rowElement.key).type) {
                    @case ('static') {
                      <div class="form-group me-1 mt-2" style="text-align: center;">{{rowElement.value}}
                      </div>
                    }
                    @case ('checkbox') {
                      <div class="form-group me-2">
                        <app-checkbox class="form-group me-1 pb-4" style="text-align: center;" [inTable]="true"
                          [checkbox]="rowElement" [targets]="findCol(table?.value?.columns,rowElement.key).targets"
                          (onValueSelected)="onComponentChange(rowIndex, index, rowElement.key, $event, rowElement)">
                        </app-checkbox>
                      </div>
                    }
                    @case ('autoincrement') {
                      <div class="form-group me-2" style="text-align: center;">
                        {{rowElement.value}}
                      </div>
                    }
                    @case ('clone') {
                      <div class="form-group me-2" style="text-align: center;">
                        {{getCloneValue(findCol(table?.value?.columns,rowElement.key).cloneKey, rowIndex)}}
                      </div>
                    }
                    @case ('radio') {
                      <div class="form-group me-2">
                        <app-radio class="form-group me-1 pb-4" style="text-align: center;" [inTable]="true"
                          [radio]="rowElement" [targets]="findCol(table?.value?.columns,rowElement.key).targets"
                          (onValueSelected)="onComponentChange(rowIndex, index, rowElement.key, $event, rowElement)">
                        </app-radio>
                      </div>
                    }
                    @case ('select') {
                      <div class="form-group me-2">
                        <app-select [select]="rowElement"
                          [targets]=findCol(table?.value?.columns,rowElement.key).targets [inTable]="true"
                          (onValueSelected)="onComponentChange(rowIndex, index, rowElement.key, $event, rowElement)">
                        </app-select>
                      </div>
                    }
                    @case ('calendar') {
                      <div class="form-group me-2">
                        <app-calendar [calendarElem]="rowElement" [inTable]="true"
                          (onDateSet)="onComponentChange(rowIndex, index, rowElement.key, $event, rowElement)">
                        </app-calendar>
                      </div>
                    }
                    @case ('textarea') {
                      <div class="form-group me-2">
                        <textarea class="form-control" id="{{rowElement.key}}" value={{rowElement.value}}
                          style="min-width: 200px; min-height: 200px;" name="{{rowElement.key}}"
                          (change)="onChange(rowIndex, index, rowElement.key, $event.target.value)">
                        </textarea>
                      </div>
                    }
                    @case ('user') {
                      <div class="form-group me-2" style="text-align: center;">
                        <!-- <label for="formElement.id">{{formElement.title}}:</label> -->
                        @if (this.user) {
                          <div style="width: 100%; text-align: center;">
                            @if (this.user.roles.length===1 && this.user.roles.includes('EDITOR')) {
                              <span>
                                {{user.name}} {{user.surname}}
                              </span>
                            }
                            @if (this.user.roles.includes('CONTROLLER') ||
                              this.user?.roles.includes('COORDINATOR') ||
                              this.user?.roles.includes('CHEF') ||
                              this.user?.roles.includes('DIRECTOR_APPROVER') ||
                              this.user?.roles.includes('DIRECTOR_GENERAL')) {
                              <span>
                                {{table.value.rows[rowIndex][table.value.rows[index].length-1].fullname}}
                              </span>
                            }
                          </div>
                        }
                      </div>
                    }
                    @default {
                      <div class="form-group me-2">
                        @if (findCol(table?.value?.columns,rowElement.key).type==='number') {
                          <input
                            [OnlyNumber]="true" thousandSeparator pattern="[0-9]+([\.,][0-9]+)*"
                            [ngStyle]="{'background-color': rowIndex===table?.value?.rows.length-1 ? 'var(--navy-50)':'white' }"
                            class="form-control" id="{{rowElement.key}}"
                            value={{rowElement.value|thousandSeparator}}
                            style="min-width: 180px;" name="{{rowElement.key}}"
                            (change)="onChange(rowIndex, index, rowElement.key, $event.target.value)">
                        } @else {
                          <input class="form-control" id="{{rowElement.key}}"
                            type="{{findCol(table?.value?.columns,rowElement.key).type}}"
                            value={{rowElement.value}}
                            [ngStyle]="{'background-color': rowIndex===table?.value?.rows.length-1 ? 'var(--navy-50)':'white' }"
                            style="min-width: 180px;" name="{{rowElement.key}}"
                            (change)="onChange(rowIndex, index, rowElement.key, $event.target.value)">
                          }
                        </div>
                      }
                    }
                  </div>
                }
              </td>
            }
            @if (table?.value?.rows.length>1) {
              <td style="padding: 5px;">
                <div class="form-group me-2">
                  <button type="button" class="btn btn-outline-danger" (click)="deleteRow(rowIndex)">-</button>
                </div>
              </td>
            }
            @if (rowIndex===table?.value?.rows.length-1) {
              <td style="padding: 5px;">
                <div class="form-group me-2">
                  <button type="button" class="btn btn-outline-primary" (click)="AddRowToTable()">+</button>
                </div>
              </td>
            }
          </tr>
        }
      </table>
    </div>
  }